import {init_burger_menu} from "./navigation/burger_menu";
import {init_menu_navigation} from "./navigation/menu";

const init_navigation = () => {
    init_burger_menu();
    init_menu_navigation();
}
export {init_navigation};

